module.exports = __webpack_public_path__ + "assets/img/logo_perfect_money.0fb24481.svg";